import { render, staticRenderFns } from "./LaboratoryIcon.vue?vue&type=template&id=8aa8d9f6&scoped=true"
import script from "./LaboratoryIcon.vue?vue&type=script&lang=js"
export * from "./LaboratoryIcon.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryIcon.vue?vue&type=style&index=0&id=8aa8d9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa8d9f6",
  null
  
)

export default component.exports